/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInProfileViewTaskCreatePriority = typeof LinkedInProfileViewTaskCreatePriority[keyof typeof LinkedInProfileViewTaskCreatePriority];


export const LinkedInProfileViewTaskCreatePriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
